import { RSAA } from 'redux-api-middleware';
import config from 'config';
export const GET_CUSTOMER_DETAILS_REQUEST = 'GET_CUSTOMER_DETAILS_REQUEST';
export const GET_CUSTOMER_DETAILS_SUCCESS = 'GET_CUSTOMER_DETAILS_SUCCESS';
export const GET_CUSTOMER_DETAILS_FAILURE = 'GET_CUSTOMER_DETAILS_FAILURE';

export const GET_CLIENT_LIST_REQUEST = 'GET_CLIENT_LIST_REQUEST';
export const GET_CLIENT_LIST_SUCCESS = 'GET_CLIENT_LIST_SUCCESS';
export const GET_CLIENT_LIST_FAILURE = 'GET_CLIENT_LIST_FAILURE';

export const UPDATE_CUSTOMER_DETAILS_REQUEST = 'UPDATE_CUSTOMER_DETAILS_REQUEST';
export const UPDATE_CUSTOMER_DETAILS_SUCCESS = 'UPDATE_CUSTOMER_DETAILS_SUCCESS';
export const UPDATE_CUSTOMER_DETAILS_FAILURE = 'UPDATE_CUSTOMER_DETAILS_FAILURE';

export const CREATE_CLIENT_REQUEST = 'CREATE_CLIENT_REQUEST';
export const CREATE_CLIENT_SUCCESS = 'CREATE_CLIENT_SUCCESS';
export const CREATE_CLIENT_FAILURE = 'CREATE_CLIENT_FAILURE';

export const GET_FAX_TEMPLATES_REQUEST = 'GET_FAX_TEMPLATES_REQUEST';
export const GET_FAX_TEMPLATES_SUCCESS = 'GET_FAX_TEMPLATES_SUCCESS';
export const GET_FAX_TEMPLATES_FAILURE = 'GET_FAX_TEMPLATES_FAILURE';


export const getCustomerDetails = (customerInfoUuid) => {
  return {
    [RSAA]: {
      endpoint: `${config.apiRoot}/customers/${customerInfoUuid}`,
      method: 'GET',
      headers: { 'Content-Type': 'application/json' },
      types: [
        GET_CUSTOMER_DETAILS_REQUEST,
        GET_CUSTOMER_DETAILS_SUCCESS,
        GET_CUSTOMER_DETAILS_FAILURE
      ]
    }
  };
};

export const createClient = (customerInfoUuid, clientData) => {
  return {
    [RSAA]: {
      endpoint: `${config.apiRoot}/customers/${customerInfoUuid}/clients/new`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(clientData),
      types: [
        CREATE_CLIENT_REQUEST,
        CREATE_CLIENT_SUCCESS,
        CREATE_CLIENT_FAILURE
      ]
    }
  };
};

export const getFaxTemplates = () => {
  return {
    [RSAA]: {
      endpoint: `${config.apiRoot}/customers/templates/list`,
      method: 'GET',
      headers: { 'Content-Type': 'application/json' },
      types: [
        GET_FAX_TEMPLATES_REQUEST,
        {
          type: GET_FAX_TEMPLATES_SUCCESS,
          payload: async (action, state, res) => {
            const text = await res.text();
            try {
              // Try to clean up common JSON issues (trailing commas)
              const cleanedText = text.replace(/,(\s*[}\]])/g, '$1');
              const data = JSON.parse(cleanedText);
              return data;
            } catch (error) {
              console.error('Error parsing fax templates response:', error);
              console.error('Response text:', text);
              throw error;
            }
          }
        },
        GET_FAX_TEMPLATES_FAILURE
      ]
    }
  };
};

export const getClientList = (customerInfoUuid, pageSize, page, sorted, filtered) => {
  return {
    [RSAA]: {
      endpoint: `${config.apiRoot}/customers/${customerInfoUuid}/clients`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ pageSize, page, sorted, filtered }),
      types: [
        {
          type: GET_CLIENT_LIST_REQUEST,
          payload: { listState: { pageSize, page, sorted, filtered } }
        },
        GET_CLIENT_LIST_SUCCESS,
        GET_CLIENT_LIST_FAILURE
      ]
    }
  };
};

export const updateCustomerDetails = (customerInfoUuid, customerData) => {
  return {
    [RSAA]: {
      endpoint: `${config.apiRoot}/customers/${customerInfoUuid}`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(customerData),
      types: [
        UPDATE_CUSTOMER_DETAILS_REQUEST,
        UPDATE_CUSTOMER_DETAILS_SUCCESS,
        UPDATE_CUSTOMER_DETAILS_FAILURE
      ]
    }
  };
};